<template>
    <LayoutSub>
        <SubSection class="pb-0" v-if="isLoading">
            <BoardCategory :cateData="category" :selectedCate="selectedCate" />
            <BoardSubCategory :cateData="category" :selectedCate="selectedCate" />
            <ListFaqPage :data="data" />
        </SubSection>
        <LoadingWrap v-else />
    </LayoutSub>
</template>
<script>
import { getFaqCategory, getFaqList } from '@/api';
import BoardCategory from '@/components/Board/BoardCategory.vue';
import BoardSubCategory from '@/components/Board/BoardSubCategory.vue';
import SubSection from '@/components/SubSection.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';
import ListFaqPage from '../common/ListFaqPage.vue';

export default {
    components: {
        LayoutSub,
        SubSection,
        BoardCategory,
        BoardSubCategory,
        ListFaqPage,
    },
    data() {
        return {
            isLoading: false,
            activeIndex: [],
            data: null,
            selectedCate: {},
            category: [],
        };
    },
    async mounted() {
        const category = await getFaqCategory(this.$route.query);
        this.category = category;
        if (!this.$route.query.page || !this.$route.query.cid || !this.$route.query.rootCid) {
            this.$router.replace({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    cid: category.mainCate[0].cid,
                    rootCid: category.mainCate[0].cid,
                    page: 1,
                },
            });
            this.selectedCate = this.category.mainCate[0];
            const { paging: data } = await getFaqList({
                cid: category.mainCate[0].cid,
                rootCid: category.mainCate[0].cid,
                page: 1,
            });
            this.data = data;
            this.isLoading = true;
        } else {
            this.selectedCate = this.category.selectedCate;
            const { paging: data } = await getFaqList(this.$route.query);
            this.data = data;
            this.isLoading = true;
        }
    },
    methods: {
        openPost(idx) {
            if (idx >= 0 && idx < this.sampleData.length && !this.activeIndex.includes(idx)) {
                this.activeIndex.push(idx);
            } else {
                this.activeIndex = this.activeIndex.filter((el) => el !== idx);
            }
        },
    },
    watch: {
        async $route(to, from) {
            if (!to.query.page || !to.query.cid || !to.query.rootCid) {
                this.$router.replace({
                    path: from.path,
                    query: {
                        ...from.query,
                    },
                });
                return;
            }
            const category = await getFaqCategory(this.$route.query);
            this.category = category;
            this.selectedCate = this.category.selectedCate;

            const data = await getFaqList(this.$route.query);
            this.data = data.paging;
        },
    },
};
</script>
